import {useEffect} from 'react';
import ViewportMgr from 'coreClasses/view/ViewportMgr';
import {useSetUI, useWindowResize} from 'coreHooks';

const MobileNavigationTriggersEffect = () => {
	const setUI = useSetUI();
	const windowResize = useWindowResize();

	useEffect(() => {
		if (ViewportMgr.getCurrentBreakpoint() === 'xxl') {
			setUI.setHeader({isNavigationOpened: false});
			setUI.setNavigationStack({});
		}
	}, [windowResize.width]);

	return null;
};

export default MobileNavigationTriggersEffect;